import React from 'react'
import Burger from '../Burger';
import LogoutSvg from '../../../../assets/icons/logout-purple.svg';
import { authActions, filterActions } from '../../../redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import './Navbar.scss';

const Navbar = ({ showMenu, onCLickBurger, burgerRef }) => {

  // const [showMenu, setShowMenu] = useState(false)
  const user = useSelector(state => state.authReducer.user)
  const dispatch = useDispatch()

  const logout = () => {
    dispatch(authActions.logout())
    dispatch(filterActions.cleanAll())
  }

  return (
    <div className='layout-navbar'>
      <Burger open={showMenu} burgerRef={burgerRef} onClick={onCLickBurger} />
      <h3>{user ? user.fullname.split(' ')[0] : 'DarkStore'}</h3>
      <img className='logout-icon' src={LogoutSvg} alt='logout' onClick={logout} />
    </div>
  )
}

export default Navbar
